export const openLiveChat = () => {
  if (typeof window?.Intercom == 'function') {
    // eslint-disable-next-line new-cap
    window?.Intercom('show');
  }
};
